import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "overlay", "image", "counter" ]

  connect() {
    this.photos = []
    this.currentIndex = 0
    this.touchStartX = 0
    this.touchEndX = 0

    this.keydownHandler = this.handleKeydown.bind(this)
    this.touchStartHandler = this.handleTouchStart.bind(this)
    this.touchEndHandler = this.handleTouchEnd.bind(this)
  }

  disconnect() {
    this.close()
    this.removeEventListeners()
  }

  open(event) {
    const target = event.currentTarget

    // Если клик произошёл внутри локального lightbox-контроллера (не body),
    // пусть его обрабатывает тот экземпляр. Это сохраняет работу существующих
    // галерей в ads/show и events/show со своей разметкой оверлея.
    const localController = target.closest('[data-controller~="lightbox"]')
    if (localController && localController !== this.element) return

    if (target.dataset.lightboxPhotos) {
      this.photos = JSON.parse(target.dataset.lightboxPhotos)
      this.currentIndex = parseInt(target.dataset.lightboxIndex, 10) || 0
    } else {
      // Обратная совместимость: галереи без data-lightbox-photos,
      // где контроллер оборачивает набор <img>.
      this.photos = Array.from(this.element.querySelectorAll("img")).map(img => img.src)
      this.currentIndex = parseInt(target.dataset.lightboxIndexParam, 10) || 0
    }

    if (!this.photos.length) return

    this.showImage()
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    this.addEventListeners()
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.removeEventListeners()
  }

  closeBackground(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  next(event) {
    event?.stopPropagation()
    if (!this.photos.length) return
    this.currentIndex = (this.currentIndex + 1) % this.photos.length
    this.showImage()
  }

  previous(event) {
    event?.stopPropagation()
    if (!this.photos.length) return
    this.currentIndex = (this.currentIndex - 1 + this.photos.length) % this.photos.length
    this.showImage()
  }

  showImage() {
    if (!this.photos.length) return
    this.imageTarget.src = this.photos[this.currentIndex]
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.currentIndex + 1} / ${this.photos.length}`
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
    if (event.key === "ArrowRight") this.next()
    if (event.key === "ArrowLeft") this.previous()
  }

  handleTouchStart(event) {
    this.touchStartX = event.changedTouches[0].screenX
  }

  handleTouchEnd(event) {
    this.touchEndX = event.changedTouches[0].screenX
    const diff = this.touchStartX - this.touchEndX
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        this.next()
      } else {
        this.previous()
      }
    }
  }

  addEventListeners() {
    document.addEventListener("keydown", this.keydownHandler)
    this.overlayTarget.addEventListener("touchstart", this.touchStartHandler, { passive: true })
    this.overlayTarget.addEventListener("touchend", this.touchEndHandler, { passive: true })
  }

  removeEventListeners() {
    document.removeEventListener("keydown", this.keydownHandler)
    this.overlayTarget.removeEventListener("touchstart", this.touchStartHandler)
    this.overlayTarget.removeEventListener("touchend", this.touchEndHandler)
  }
}
